// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"166a3ca6","455":"6d583402","977":"8b218a4d"}[chunkId] + ".chunk.js";
};